import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UIActionModal } from "../../../components/ui";

/** Delete confirmation for an employee. */
const DeleteEmployeeModal = ({ open, employee, copy, onClose, onConfirm }) => {
  const employeeName = employee?.name ?? "";
  const message = copy.question.replace("{name}", employeeName);

  return (
    <UIActionModal
      open={open}
      onClose={onClose}
      title={copy.title}
      variant="reject"
      maxWidth="sm"
      PaperProps={{ className: "team-management-delete-modal" }}
      actions={
        <UIActionModal.Actions
          cancelLabel={copy.cancel}
          confirmLabel={copy.delete}
          confirmVariant="reject"
          onCancel={onClose}
          onConfirm={onConfirm}
        />
      }
    >
      <Typography className="team-management-delete-modal__message">
        {message}
      </Typography>
    </UIActionModal>
  );
};

DeleteEmployeeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  employee: PropTypes.shape({
    name: PropTypes.string,
  }),
  copy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    delete: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DeleteEmployeeModal.defaultProps = {
  employee: null,
};

export default DeleteEmployeeModal;
